var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"design"},[_c('i',{staticClass:"el-icon-plus"})]),_c('p',[_vm._v("请选择图片 每张图不超过10MB")])])
}]

export { render, staticRenderFns }